'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _input = require('../../atoms/input');

var _input2 = _interopRequireDefault(_input);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _script = require('../../hocs/script');

var _script2 = _interopRequireDefault(_script);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlaceAutocomplete = function (_React$Component) {
    _inherits(PlaceAutocomplete, _React$Component);

    function PlaceAutocomplete(props) {
        _classCallCheck(this, PlaceAutocomplete);

        var _this = _possibleConstructorReturn(this, (PlaceAutocomplete.__proto__ || Object.getPrototypeOf(PlaceAutocomplete)).call(this, props));

        _this.handleQueryChanged = function (value) {
            _this.setState({
                searchText: value
            });
            _this.handleChange('placeInfo', { code: null, businessName: value, location: {} });
        };

        _this.handleScriptLoad = function () {
            var countryCode = _this.props.countryCode && String(_this.props.countryCode).toLowerCase();
            var placeTypes = _this.props.placeTypes ? _this.props.placeTypes.split('|') : ['establishment'];

            var options = {
                componentRestrictions: { country: countryCode || 'can' },
                fields: ['place_id', 'address_components', 'formatted_address', 'geometry', 'name'],
                types: placeTypes
            };
            /*global google*/
            _this.autocomplete = new google.maps.places.Autocomplete(document.getElementById('PlaceAutoComplete-' + _this.state.id + '-Input'), options);
            _this.autocomplete.addListener('place_changed', _this.handlePlaceSelect);

            _this.setState({ loaded: true });
            if (_this.props.placeInfo && _this.props.placeInfo.businessName) {
                _this.setState({
                    searchText: _this.props.placeInfo.businessName && _this.props.placeInfo.formattedAddress ? _this.props.placeInfo.businessName + ', ' + _this.props.placeInfo.formattedAddress : _this.props.placeInfo.businessName
                });
            }
        };

        _this.handlePlaceSelect = function () {
            var placeObject = _this.autocomplete.getPlace();
            var placeInfo = null;
            if (placeObject) {
                placeInfo = {};
                placeInfo.businessName = placeObject.name;
                placeInfo.code = placeObject.place_id;
                placeInfo.streetNumber = _this.getAddressComponent(placeObject, 'street_number', true);
                placeInfo.street = _this.getAddressComponent(placeObject, 'route', true);
                placeInfo.city = _this.getAddressComponent(placeObject, 'locality', true);
                if (placeInfo.city === null || placeInfo.city === undefined) {
                    placeInfo.city = _this.getAddressComponent(placeObject, 'sublocality_level_1', true);
                }
                placeInfo.state = _this.getAddressComponent(placeObject, 'administrative_area_level_1', true);
                placeInfo.stateCode = _this.getAddressComponent(placeObject, 'administrative_area_level_1');
                placeInfo.country = _this.getAddressComponent(placeObject, 'country', true);
                placeInfo.countryCode = _this.getAddressComponent(placeObject, 'country');

                // Every time new country is added, add here too! (Need to find better way for this)
                if (placeInfo.countryCode === 'CA') {
                    placeInfo.countryCode = 'CAN';
                }
                if (placeInfo.countryCode === 'US') {
                    placeInfo.countryCode = 'USA';
                }

                placeInfo.postalCode = _this.getAddressComponent(placeObject, 'postal_code', true);
                placeInfo.formattedAddress = placeObject.formatted_address;
                placeInfo.location = {
                    latitude: '' + placeObject.geometry.location.lat(),
                    longitude: '' + placeObject.geometry.location.lng()
                };

                _this.setState({ searchText: placeInfo.businessName + ', ' + placeInfo.formattedAddress });
                if (_this.props.placeInfo && _this.props.placeInfo.apartmentSuite) {
                    placeInfo.apartmentSuite = _this.props.placeInfo.apartmentSuite;
                }
                placeInfo.formattedAddress = _this.getFormattedAddress(placeInfo);

                _this.handleChange('placeInfo', placeInfo);
            }
        };

        _this.getAddressComponent = function (place, type) {
            var long = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var value = null;
            if (place && place.address_components && place.address_components.length > 0) {
                var component = place.address_components.find(function (x) {
                    return x.types.some(function (y) {
                        return y === type;
                    });
                });
                if (component) {
                    value = long ? component.long_name : component.short_name;
                }
            }
            return value;
        };

        _this.getFormattedAddress = function (address) {
            var formattedAddress = '';
            if (address) {
                if (address.apartmentSuite && address.apartmentSuite.length > 0) {
                    formattedAddress = address.apartmentSuite + '-';
                }
                if (address.streetNumber && address.streetNumber.length > 0) {
                    formattedAddress = '' + formattedAddress + address.streetNumber + ' ';
                }
                if (address.street && address.street.length > 0) {
                    formattedAddress = '' + formattedAddress + address.street;
                }
                if (address.city && address.city.length > 0) {
                    formattedAddress = formattedAddress + ', ' + address.city;
                }
                if (address.stateCode && address.stateCode.length > 0) {
                    formattedAddress = formattedAddress + ', ' + address.stateCode;
                } else if (address.state && address.state.length > 0) {
                    formattedAddress = formattedAddress + ', ' + address.state;
                }
                if (address.postalCode && address.postalCode.length > 0) {
                    formattedAddress = formattedAddress + ' ' + address.postalCode;
                }
                if (address.country && address.country.length > 0) {
                    formattedAddress = formattedAddress + ', ' + address.country;
                }
            }
            return formattedAddress;
        };

        _this.handleChange = function (code, value) {
            if (code === 'placeInfo') {
                _this.props.changeEvent(code, value, _this.state.error);
            } else {
                var placeInfo = _extends({}, _this.props.placeInfo);
                placeInfo[code] = value;
                placeInfo.formattedAddress = _this.getFormattedAddress(placeInfo);
                _this.props.changeEvent('placeInfo', placeInfo);
            }
        };

        _this.state = {
            id: Math.random().toString(36).slice(2, 11),
            searchText: null,
            loaded: false,
            error: ''
        };
        return _this;
    }

    _createClass(PlaceAutocomplete, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!this.state.loaded && this.state.searchText === null && this.props.placeInfo && this.props.placeInfo.businessName && this.props.placeInfo.formattedAddress) {
                this.setState({ searchText: this.props.placeInfo.businessName + ', ' + this.props.placeInfo.formattedAddress });
            }

            if (this.state.searchText && this.state.searchText.length > 3 && !this.state.loaded && window.google) {
                this.handleScriptLoad();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (!this.state.loaded && window.google) {
                this.handleScriptLoad();
            }

            if (this.state.loaded && this.state.searchText === null && this.props.placeInfo && this.props.placeInfo.businessName && this.props.placeInfo.formattedAddress) {
                this.setState({ searchText: this.props.placeInfo.businessName + ', ' + this.props.placeInfo.formattedAddress });
            }

            if (this.props.placeInfo && !this.props.placeInfo.code && this.props.placeInfo.formattedAddress && prevProps.placeInfo && prevProps.placeInfo.formattedAddress && (this.props.placeInfo.businessName !== prevProps.placeInfo.businessName || this.props.placeInfo.formattedAddress !== prevProps.placeInfo.formattedAddress)) {
                this.props.changeEvent('placeInfo', {
                    businessName: this.props.placeInfo.businessName,
                    formattedAddress: this.props.placeInfo.formattedAddress,
                    apartmentSuite: this.props.placeInfo.apartmentSuite,
                    location: {}
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _grid2.default,
                null,
                _react2.default.createElement(
                    _row2.default,
                    { nogutter: true },
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12,
                            nogutterleft: true,
                            nogutterright: this.context.screen.isMobile
                        },
                        _react2.default.createElement(_input2.default, { id: 'PlaceAutoComplete-' + this.state.id + '-',
                            key: 'PlaceAutoComplete-' + this.state.id + '-',
                            top: this.props.top,
                            label: this.props.label,
                            value: this.state.searchText,
                            placeholder: this.props.placeholder,
                            changeEvent: this.handleQueryChanged,
                            className: this.props.className,
                            error: this.props.error || !!this.state.error,
                            errorLabel: !this.props.hideError && this.state.error,
                            disabled: this.props.disabled,
                            isCheckDOMValue: this.props.isCheckDOMValue,
                            hideClearBtn: this.props.hideClearBtn
                        })
                    )
                )
            );
        }
    }]);

    return PlaceAutocomplete;
}(_react2.default.Component);

PlaceAutocomplete.contextTypes = {
    screen: _propTypes2.default.object
};

var WrappedPlaceAutocomplete = (0, _script2.default)(PlaceAutocomplete, 'gMaps', 'https://maps.googleapis.com/maps/api/js?libraries=places&key=@&gMaps&@');

exports.default = WrappedPlaceAutocomplete;